module.exports = __webpack_public_path__ + "assets/img/WinterStore_tit.d3c66e20.png";